import React from 'react';
import CustomButtonWithIcon from "../../../../components/CustomButtonWithIcon/Buttons";
import Icons from "../../../../components/DmpIcons/icons";
import SlidingPanel from "../SlidingPanel";
import GoogleSearchAdsCampaignListTable from "../../ListTable/CampaignsListTable/google-search-ads";
import PMaxCampaignListTable from "../../ListTable/CampaignsListTable/PMax";
import SelectedCampaigns from "../../Tools/SelectedCampaigns";

const CampaignSelection = ({
                            isOpen, setOpen, selectedCampaigns, campaignType, handleRemoveCampaign, handleClearAllCampaigns,
                            handleCampaignSelect, campaignRowSelection, setCampaignRowSelection,
                            idaccount, jwtToken, showError
                        }) => (
    <div>
        <div className="selected-hotels-view">
            <div className="button-container">
                <CustomButtonWithIcon
                    color="#f9f9f9"
                    hoverColor="#f9f9f9"
                    titleColor="#BAB7b7"
                    hoverTitleColor={"#BAB7b7"}
                    icon={Icons.ActionsIcons.AddIcon}
                    iconSize={"14px"}
                    width={"120px"}
                    height={"24px"}
                    borderRadius="20px"
                    textStyle={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '14.52px',
                        textAlign: 'center',
                    }}
                    onClick={() => setOpen(true)}
                >
          <span style={{ fontSize: "10px", fontFamily: "Inter, sans-serif", fontWeight: 400 }}>
            Add Campaigns
          </span>
                </CustomButtonWithIcon>
            </div>
            <div>
                <SelectedCampaigns
                    selectedCampaigns={selectedCampaigns}
                    handleRemoveCampaign={handleRemoveCampaign}
                    handleClearAllCampaigns={handleClearAllCampaigns}
                />
                {showError && (
                    <span style={{ color: '#d32f2f', fontSize: '12px' }}>
            Please select at least one campaign
          </span>
                )}
            </div>
        </div>
        <SlidingPanel size={40} isOpen={isOpen} onClose={() => setOpen(false)}>
            {campaignType === "GOOGLE_SEARCH_ADS_CAMPAIGN" ? (
                <GoogleSearchAdsCampaignListTable
                    idaccount={idaccount}
                    jwtToken={jwtToken}
                    onCampaignSelect={handleCampaignSelect}
                    rowSelection={campaignRowSelection}
                    setRowSelection={setCampaignRowSelection}
                    onClose={() => setOpen(false)}
                />
            ) : campaignType === "PMAX_CAMPAIGN" ? (
                <PMaxCampaignListTable
                    idaccount={idaccount}
                    jwtToken={jwtToken}
                    onCampaignSelect={handleCampaignSelect}
                    rowSelection={campaignRowSelection}
                    setRowSelection={setCampaignRowSelection}
                    onClose={() => setOpen(false)}
                />
             ) : null
            }
        </SlidingPanel>

    </div>
);

export default CampaignSelection;
